import type { Message } from "../features/chat/types/UIMessage";

// Re-export for any existing imports
export type { Message, MessageType, DeliveryStatus } from "../features/chat/types/UIMessage";

export const DUMMY_MESSAGES: Record<string, Message[]> = {
  "1": [
    {
      id: "1-1",
      type: "received",
      userName: "Kovaleski, Winston",
      avatarLabel: "KW",
      content: "Good morning! Just checking in on the medication schedule for today.",
      timestamp: "20/12/2025 8:10AM",
    },
    {
      id: "1-2",
      type: "sent",
      content: "Good morning! Everything is on track. Medications have been administered at 8AM.",
      timestamp: "20/12/2025 8:15AM",
      status: "read",
    },
    {
      id: "1-3",
      type: "received",
      userName: "Kovaleski, Winston",
      avatarLabel: "KW",
      content: "Great, thank you for the update. Please let me know if there are any changes.",
      timestamp: "20/12/2025 8:20AM",
    },
    {
      id: "1-4",
      type: "sent",
      content: "Will do. I'll send over the afternoon report as well.",
      timestamp: "20/12/2025 8:22AM",
      status: "delivered",
    },
  ],
  "2": [
    {
      id: "2-1",
      type: "received",
      userName: "Jane Doe",
      avatarLabel: "JD",
      content: "Good news! Mrs. Thompson's latest blood work is normal.",
      timestamp: "20/12/2025 8:25AM",
    },
    {
      id: "2-2",
      type: "sent",
      content: "Great! The lab results for Room 204 look good. No immediate concerns.",
      timestamp: "20/12/2025 8:30AM",
      status: "read",
    },
    {
      id: "2-3",
      type: "received",
      userName: "Jane Doe",
      avatarLabel: "JD",
      content: "Good morning! Just a reminder that Mrs. Thompson's appointment with Dr. Crane is scheduled for 10:00 AM today.",
      timestamp: "22/07/2026 9:00AM",
    },
    {
      id: "2-4",
      type: "sent",
      content: "Thanks, noted. I'll make sure she takes her medication beforehand.",
      timestamp: "22/07/2026 9:05AM",
      status: "read",
    },
    {
      id: "2-5",
      type: "received",
      userName: "Jane Doe",
      avatarLabel: "JD",
      content: "Perfect. Let me know once the appointment is done.",
      timestamp: "22/07/2026 9:10AM",
    },
    {
      id: "2-6",
      type: "sent",
      content: "Good morning! The appointment went well. Dr. Crane is adjusting her prescription.",
      timestamp: "23/07/2026 8:00AM",
      status: "delivered",
    },
    {
      id: "2-7",
      type: "received",
      userName: "Jane Doe",
      avatarLabel: "JD",
      content: "That's great to hear. I'll update the care plan accordingly.",
      timestamp: "23/07/2026 8:15AM",
    },
    {
      id: "2-8",
      type: "sent",
      content: "Thanks Jane! Everything is under control on this end.",
      timestamp: "23/07/2026 8:20AM",
      status: "sent",
    },
  ],
  "3": [
    {
      id: "3-1",
      type: "received",
      userName: "Beaufort, Annelise",
      avatarLabel: "BA",
      content: "Hi, can you check on Mr. Davis in room 310? He's been asking about his discharge papers.",
      timestamp: "23/07/2026 9:00AM",
    },
    {
      id: "3-2",
      type: "sent",
      content: "On it! I'll head over now and check with the doctor on call.",
      timestamp: "23/07/2026 9:05AM",
      status: "read",
    },
    {
      id: "3-3",
      type: "sent",
      content: "Spoke with Dr. Lee. Discharge papers should be ready by noon.",
      timestamp: "23/07/2026 9:20AM",
      status: "sent",
    },
  ],
  "4": [
    {
      id: "4-1",
      type: "sent",
      content: "Good afternoon, Mr. Thompson. How are you feeling today?",
      timestamp: "22/07/2026 2:00PM",
      status: "read",
    },
    {
      id: "4-2",
      type: "received",
      userName: "Thompson, Gerald",
      avatarLabel: "TG",
      content: "A bit better, thank you. The new medication seems to be helping.",
      timestamp: "22/07/2026 2:10PM",
    },
    {
      id: "4-3",
      type: "sent",
      content: "Glad to hear that. Dr. Patel will stop by for rounds at 4PM.",
      timestamp: "22/07/2026 2:12PM",
      status: "delivered",
    },
  ],
  "5": [
    {
      id: "5-1",
      type: "received",
      userName: "Martinez, Sofia",
      avatarLabel: "MS",
      content: "Please note that we have a family visitor request for room 305 today at 3PM.",
      timestamp: "28/06/2026 10:00AM",
    },
    {
      id: "5-2",
      type: "sent",
      content: "Noted. I'll make sure the room is prepared and the patient is aware.",
      timestamp: "28/06/2026 10:05AM",
      status: "read",
    },
    {
      id: "5-3",
      type: "received",
      userName: "Martinez, Sofia",
      avatarLabel: "MS",
      content: "Thank you! Also, can you confirm the dietary restrictions for the patient?",
      timestamp: "28/06/2026 10:08AM",
    },
    {
      id: "5-4",
      type: "sent",
      content: "The patient has a gluten-free diet. I'll inform the kitchen team.",
      timestamp: "28/06/2026 10:15AM",
      status: "sent",
    },
  ],
};
